const publicKeyPEM = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA+VLgn4QkIbu52QTFHa77
1Bpm1K6Ac8zr7mfm8hcU8mbwiFbXKbuIoafNKqPmQZLMAwwos0WKWbZ0hmhYt049
1o4DsTve70z8mIOvc47Fl8p8D48fp0Y3ZHNnEvR2bsmgOYML/L6hlkYKGg7uFdIQ
PqvcgXSDwFEiQL7bNwQbIh3jBU1ucoGZzqL90p1CtOikodyPzvga1EtE4Y3I3sel
OZE8C/1xVg8iNUF9l79eXEMe0/DGDKS82nVxHQMgcgCTCTDEy4XouSa8mLiwaHLH
q99uR6Ez5JVSedDfdIT2GYKPReRMhBC2moyrY+mTk6BseI2P7i9aPQ/KHSisRNoy
1wIDAQAB
-----END PUBLIC KEY-----`;

export default publicKeyPEM;
